import {
  WorkTypeFilenameTemplateItem,
  ControlPointFilenameTemplateItem,
  InspectionFilenameTemplateItem,
  PunchListFilenameTemplateItem,
} from '../classes/dailyInspection'
import { dateOptions } from '../utils'

export const DailyInspectionWorkType = new WorkTypeFilenameTemplateItem({
  id: 'FB746DBD-1EBF-42D3-BB62-1B6F16AB9A1D',
  name: 'Work Type',
  property: 'name',
  help: 'Name from Daily Inspection Work Type table',
  exampleValue: 'Granular Backfill Borrow',
})

export const DailyInspectionShortName = new WorkTypeFilenameTemplateItem({
  id: '9E7A2441-0E83-43A5-9BA9-2956705938EE',
  name: 'Work Type Short Name',
  property: 'shortName',
  help: 'PDF Naming Convention Name (Short Name) from Daily Inspection Work Type table',
  exampleValue: 'GBB',
})

export const DailyControlPointDate = new ControlPointFilenameTemplateItem({
  id: '8BE3DA8F-FD6D-4D24-943A-A36454F34530',
  name: 'Report Date',
  property: 'reportDate',
  ...dateOptions({
    name: 'Report Date',
    tableNameSingular: 'Daily Inspection Control Point',
  }),
})

export const DailyControlPointId = new ControlPointFilenameTemplateItem({
  id: 'AFCF61AF-C3D9-4440-8F0B-0163BC715DE5',
  name: 'Control Point ID',
  property: 'controlPointId',
  help: 'Inspection ID from Daily Inspection Control Point table',
  exampleValue: 'PLA-0014',
})

export const DailyInspectionDate = new InspectionFilenameTemplateItem({
  id: 'DA0C0657-9825-42B6-80A5-F2FED9A8049C',
  name: 'Report Date',
  property: 'reportDate',
  ...dateOptions({
    name: 'Report Date',
    tableNameSingular: 'Daily Inspection Inspection',
  }),
})

export const DailyInspectionId = new InspectionFilenameTemplateItem({
  id: '4021A0C2-22EB-402D-B14A-F427E58C54D3',
  name: 'Inspection ID',
  property: 'inspectionId',
  help: 'Inspection ID from Daily Inspection Inspection table',
  exampleValue: 'PLA-0014',
})

export const DailyPunchListDate = new PunchListFilenameTemplateItem({
  id: 'A795C8A9-4FA6-47C3-AB2F-E042F49EC233',
  name: 'Report Date',
  property: 'reportDate',
  ...dateOptions({
    name: 'Report Date',
    tableNameSingular: 'Daily Inspection Punch List',
  }),
})

export const DailyPunchListId = new PunchListFilenameTemplateItem({
  id: '9F17133F-A5E3-4321-A2B5-26A0CC183CE1',
  name: 'Punch List ID',
  property: 'punchListId',
  help: 'Inspection ID from Daily Inspection Punch List table',
  exampleValue: 'PLA-0014',
})

export type DailyInspectionFilename =
  | typeof DailyInspectionWorkType
  | typeof DailyInspectionShortName
  | typeof DailyControlPointDate
  | typeof DailyControlPointId
  | typeof DailyInspectionDate
  | typeof DailyInspectionId
  | typeof DailyPunchListDate
  | typeof DailyPunchListId
